
import { TripsActions, TripsState } from "types/store";


const originalFilters = {
  "Client": [],
    "Time Range": [
    { label: "Last 3 days", value: "Last 3 days" },
    { label: "Last week", value: "Last week" },
    { label: "Last month", value: "Last month" },
    { label: "Custom", value: "Custom" },
  ],

};

const updatedFilters = {
  "Client": [],
   "Time Range": [{ label: "Last month", value: "Last month" }],
};

const initialState: TripsState = {
  page: {
    selectedPage: 1,
    totalElements: 0,
    totalPages: 0,
  },
  riderTripsPage: {
    selectedPage: 1,
    totalElements: 0,
    totalPages: 0,
  },
filters: {
    original: originalFilters,
    updated: updatedFilters,
  },
  search: "",

  logsPage:  {
    selectedPage: 1,
    totalElements: 0,
    totalPages: 0,
  },
};

export default function tripsReducer(
  state: TripsState = initialState,
  action: TripsActions
): TripsState {
  switch (action.type) {
    case "SET_TRIPS_TABLE":
      return { ...state, tripsCenter: action.payload };
      case "SET_RIDER_TRIPS_TABLE":
      return { ...state, riderTrips: action.payload };
       case "SET_DOWNLOAD_TRIPS_TABLE":
      return { ...state, downloadTrips: action.payload };
      case "SET_TOTAL_TRIPS":
        return { ...state, totalTrips: action.payload };
            case "SET_TRIPS_ORIGINAL_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, original: action.payload },
      };
    case "SET_TRIPS_UPDATED_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, updated: action.payload },
      };
        case "SET_TOTAL_KMS":
          return { ...state, totalKmDriven: action.payload };
    case "SET_TRIP_SELECTED_PAGE":
      return {
        ...state,
        page: { ...state.page, selectedPage: action.payload },
      };
      case "SET_RIDER_TRIP_SELECTED_PAGE":
      return {
        ...state,
        riderTripsPage: { ...state.riderTripsPage, selectedPage: action.payload },
      };
    case "SET_LOGS_SELECTED_PAGE":
      return {
        ...state,
        logsPage: { ...state.logsPage, selectedPage: action.payload },
      };
    case "SET_LOGS_TOTAL_PAGE":
        return { ...state, logsPage: { ...state.logsPage, ...action.payload } };
    case "SET_TRIP_TOTAL_PAGE":
      return { ...state, page: { ...state.page, ...action.payload } };
      case "SET_RIDER_TRIP_TOTAL_PAGE":
      return { ...state, riderTripsPage: { ...state.riderTripsPage, ...action.payload } };
    case "SET_TRIP_COORDINATE":
      return  { ...state, tripCoordinate: action.payload };
    case "SET_TRIPS_SEARCH":
      return {
        ...state,
        search: action.payload,
      };
    default:
      return state;
  }
}
